import { Component, EventEmitter, Output } from '@angular/core';
import { FloormapUiService } from '../../services/floormap-ui.service';
import {
  ROOMS,
  DOORS,
  WINDOWS,
  MISCELLANEOUS,
  FURNISHINGS,
} from '../../shapes/shapes.library';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'kanzi-floormap-items-palette',
    templateUrl: './floormap-items-palette.component.html',
    styleUrls: ['./floormap-items-palette.component.scss'],
    standalone: false
})
export class FloormapItemsPaletteComponent {
  @Output() roomSelected = new EventEmitter<string>()
  roomsList: SelectItem[] = [];
  doorsList: any[] = [];
  windowList: any[] = [];
  missList: any[] = [];
  Furniture:any[] =[]
  constructor(private floormapUIService: FloormapUiService) {}

  ngOnInit(): void {
    this.roomsList = ROOMS.map((room) => {
      return { label: room.title, value: room };
    });
    this.doorsList = DOORS;
    this.windowList = WINDOWS;
    this.missList = MISCELLANEOUS;
    this.Furniture = FURNISHINGS
  }

  insert(object: any, type: string) {
    this.floormapUIService.insertObject.next({ type, object });
    if(type==='ROOM'){
      this.roomSelected.emit(object['title']);
    }
  }
}
